import { ComponentType } from "react";
import SectionAccordion from "@/pages/app/provider/patient/patient-list/patient-chart-new/patient-visit-note/encounter/note-forms/readmission-f2f/components/SectionAccordion";
import { ScreeningAssessmentProps } from "@/pages/app/provider/scheduling/appointment/encounter/Assessment/ScreeningAssessment";
import AnnualWellnessAssessment from "@/pages/app/provider/scheduling/appointment/encounter/Assessment/home-health/AnnualWellnessAssessment";
import DiabeticAssessment from "@/pages/app/provider/scheduling/appointment/encounter/Assessment/home-health/DiabeticAssessment";
import ObesityAssessment from "@/pages/app/provider/scheduling/appointment/encounter/Assessment/home-health/ObesityAssessment";
import SmokingAssessment from "@/pages/app/provider/scheduling/appointment/encounter/Assessment/home-health/SmokingAssessment";

type AssessmentComponent = ComponentType<
  Omit<ScreeningAssessmentProps, "type">
>;

/** Note section key → the Home Health screening it renders. */
export const HOME_HEALTH_ASSESSMENTS: Record<string, AssessmentComponent> = {
  annualWellness: AnnualWellnessAssessment,
  diabeticScreening: DiabeticAssessment,
  smokingScreening: SmokingAssessment,
  obesityScreening: ObesityAssessment,
};

export interface HomeHealthAssessmentSectionProps {
  title: string;
  expanded: boolean;
  onToggle: () => void;
  assessmentKey: keyof typeof HOME_HEALTH_ASSESSMENTS;
}

const HomeHealthAssessmentSection = ({
  title,
  expanded,
  onToggle,
  assessmentKey,
}: HomeHealthAssessmentSectionProps) => {
  const Assessment = HOME_HEALTH_ASSESSMENTS[assessmentKey];

  return (
    <SectionAccordion
      title={title}
      expanded={expanded}
      onToggle={onToggle}
      showCurrentVisit={false}
    >
      <Assessment isEnabled={expanded} />
    </SectionAccordion>
  );
};

export default HomeHealthAssessmentSection;
